import { conferenceStandingsHref, navigateSPA } from "./useURLState";

// ConferenceLink renders a conference label as an <a> that deep-links
// into Standings filtered to that conference. Left-click triggers SPA
// navigation (no full page reload); modified clicks (middle-button,
// cmd/ctrl, shift, open-in-new-tab from the context menu) fall through
// to the browser's default behavior via the real href.
export function ConferenceLink({
  conference,
  sport,
  division,
  label,
  title,
  className,
}: {
  conference: string;
  sport: string;
  division: string;
  label: string;
  title?: string;
  className?: string;
}) {
  if (!conference) return <span className={className}>{label}</span>;
  const href = conferenceStandingsHref(conference, sport, division);
  return (
    <a
      href={href}
      title={title}
      className={className ? `conf-link ${className}` : "conf-link"}
      onClick={(e) => {
        // Preserve the browser's default for modified clicks so
        // middle-click, cmd/ctrl-click, and shift-click still open
        // the link in a new tab / window.
        if (
          e.button !== 0 ||
          e.metaKey ||
          e.ctrlKey ||
          e.shiftKey ||
          e.altKey
        ) {
          return;
        }
        e.preventDefault();
        navigateSPA(href);
      }}
    >
      {label}
    </a>
  );
}
